module.exports = __webpack_public_path__ + "img/logo.41bd6df0.png";